import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { BaseClass } from '../../classes/base';
import { TranslationService } from '../../services/translation.service';
import { CyclePreview } from '../../interfaces/cycle.interface';

@Component({
  selector: 'app-select-cycle',
  templateUrl: './select-cycle.component.html',
  styleUrls: ['./select-cycle.component.scss'],
})
export class SelectCycleComponent extends BaseClass implements AfterViewInit {

  @Input() cycles: CyclePreview[] = [];
  @Input() selectedCycleId: number = 0;
  private originalCycleId: number = 0;

  constructor(
    _toastController: ToastController
    , _translationService: TranslationService
    , private _modalController: ModalController) {
    super(_toastController, _translationService);
  }

  ngAfterViewInit() {
    this.originalCycleId = this.selectedCycleId;
    this.cycles.forEach(c => c.id = c.id ? c.id : c.cycleId);
  }

  public selectCycle(cycleId: number) {
    this.selectedCycleId = cycleId;
    this.cycles.forEach(c => c.selected = c.id === cycleId);
  }

  public dismiss(wasSelected: boolean = false) {
    if (wasSelected)
      this._modalController.dismiss(this.selectedCycleId);
    else {
      this.selectCycle(this.originalCycleId);
      this._modalController.dismiss();
    }
  }
}
